<template>
  <div>
    <!-- 黑名单店铺订单号 -->
    <el-dialog :title="$t('message.blacklistedStoreOrderNumber')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="600px" center>
      <div class="content">
        请注意 !!!!!!!!
        <p>该订单店铺已被公司拉黑（问题店铺或者诈骗团伙），请不要购买该店铺商品</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="dialogVisible = false">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    blackShopOrder() {
      let datas = {
        orderSnSet: [this.$route.query.order_sn]
      }
      this.$api.orderApi.blackShopOrder(datas).then(res => {
        if (res.data != false) {
          this.dialogVisible = true
        }

      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  font-size: 30px;
  color: #B4272D;
  font-weight: 700;

}
</style>